/* DON'T EDIT THIS FILE: edit original and run build again */ import { useIsMounted } from "../../framework/react/use-is-mounted.ts";
import { useState } from "react";
import { Button, ButtonProps } from "react-bootstrap";

type ExtraButtonProps = Omit<ButtonProps, "onClick" | "disabled">;

type ClickLoadingCallback = (
  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => Promise<unknown>;

export const ManualLoadingButton = ({
  disabled = false,
  onClick,
  loading,
  children,
  ...props
}: {
  loading: boolean;
  disabled?: boolean;
  onClick: ClickLoadingCallback;
} & ExtraButtonProps) => {
  return (
    <Button
      type="button"
      disabled={loading || disabled}
      onClick={onClick}
      style={{
        /* FIXME@UX */ position: "relative",
        overflow: "hidden",
      }}
      variant={"primary"}
      {...props}
    >
      {loading ? <div className="btn-loader" /> : null}
      {children}
    </Button>
  );
};

export const useLoadingCallback = (
  callback: ClickLoadingCallback
): [boolean, ClickLoadingCallback] => {
  const isMounted = useIsMounted();
  const [saving, setSaving] = useState(false);
  return [
    saving,
    async (event) => {
      setSaving(true);
      try {
        await callback(event);
      } finally {
        if (isMounted()) {
          setSaving(false);
        }
      }
    },
  ];
};

export const LoadingButton = ({
  onClick,
  disabled,
  ...props
}: {
  disabled?: boolean;
  onClick: ClickLoadingCallback;
} & ExtraButtonProps) => {
  const [loading, save] = useLoadingCallback(onClick);
  return (
    <ManualLoadingButton
      onClick={save}
      loading={loading}
      disabled={disabled}
      {...props}
    />
  );
};
